export default __webpack_public_path__ + "static/media/Powerpoint_Default_Icon.b992e5d0.svg";